import {ChangeDetectionStrategy, Component, effect, inject, signal} from '@angular/core';
import {
    FormBuilder, FormControl,
    FormGroup,
    ReactiveFormsModule,
    Validators
} from "@angular/forms";
import {
    FormCheckboxComponent
} from "../../../common/forms/form-checkbox/form-checkbox.component";
import {
    AppAlertService,
    SettingsAccountService,
    SubtitlesService
} from "../../../core";
import {NgOptimizedImage} from "@angular/common";
import {
    FormButtonComponent
} from "../../../common/forms/form-button/form-button.component";

@Component({
    selector: 'service24-form',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        FormCheckboxComponent,
        NgOptimizedImage,
        FormButtonComponent,
    ],
    templateUrl: './service24-form.component.html',
    styleUrl: './service24-form.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class Service24FormComponent {
    private readonly appAlert = inject(AppAlertService);
    private readonly fb = inject(FormBuilder);
    readonly settingsAccount = inject(SettingsAccountService);
    private readonly subtitles = inject(SubtitlesService);

    readonly service24Form: FormGroup<{
        acceptService24Policy: FormControl<boolean>;
    }> = this.fb.nonNullable.group({
        acceptService24Policy: [{
            value: this.settingsAccount.service24PolicyAccepted() === true,
            disabled: this.settingsAccount.service24PolicyAccepted() === true
        }, [Validators.requiredTrue]]
    });
    readonly showFullText = signal(this.settingsAccount.service24PolicyAccepted() === false);

    constructor() {
        effect(() => {
            const policyAccepted = this.settingsAccount.service24PolicyAccepted();
            this.showFullText.set(policyAccepted === false);
            if (policyAccepted === true) {
                this.acceptService24PolicyControl.setValue(true);
                this.acceptService24PolicyControl.disable();
            } else {
                this.acceptService24PolicyControl.enable();
            }
        }, {allowSignalWrites: true});
    }

    get acceptService24PolicyControl(): FormControl<boolean> {
        return this.service24Form.controls.acceptService24Policy;
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }

    toggleText() {
        this.showFullText.update((value) => !value);
    }

    saveAgreement() {
        const acceptService24Policy = this.acceptService24PolicyControl.value;
        if (!acceptService24Policy) {
            this.appAlert.openAlertDialog({
                title: this.subtitles.setSubtitle(8607),
                message: this.subtitles.setSubtitle(5062),
                okButtonText: this.subtitles.setSubtitle(1136),
            })
            return;
        }
        this.settingsAccount.saveService24policy(acceptService24Policy).subscribe({
            next: (policyAccepted) => {
                if (policyAccepted) {
                    this.appAlert.openAlertDialog({
                        title: '',
                        message: this.subtitles.setSubtitle(1970),
                        okButtonText: this.subtitles.setSubtitle(475),
                    });
                } else {
                    this.showSaveError();
                }
            },
            error: () => this.showSaveError()
        });
    }

    private showSaveError(): void {
        this.appAlert.openAlertDialog({
            title: '',
            message: this.subtitles.setSubtitle(1941),
            okButtonText: this.subtitles.setSubtitle(1136),
        });
    }
}
